import React from 'react';
import { useNavigate } from 'react-router-dom';
import { styled } from 'styled-components';

import { useOnlineMonitor } from 'utils/hooks/useOnlineMonitor';

const StyledRedirect = styled.div`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 16px;
  text-decoration-line: underline;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const StyledRedirectOffline = styled.div`
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const RelatedToIncidentValue = styled.p`
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.15px;
  margin: 0;
`;

type EntityDisplayValueProps = {
  link: string | undefined;
  path: string;
};

const EntityDisplayValue: React.FC<EntityDisplayValueProps> = ({ link, path }) => {
  const navigate = useNavigate();
  const isOnline = useOnlineMonitor();

  if (link === undefined) {
    return null;
  }

  const navigateToSite = (event: React.MouseEvent): void => {
    navigate(path);
    event.stopPropagation();
  };

  if (!isOnline) {
    return (
      <StyledRedirectOffline>
        <RelatedToIncidentValue id={`offline-lookup-${path.split('/')[1]}`}>{link}</RelatedToIncidentValue>
      </StyledRedirectOffline>
    );
  }

  return (
    <StyledRedirect onClick={navigateToSite} role="link">
      <RelatedToIncidentValue id={`linked-${path.split('/')[1]}`}>{link}</RelatedToIncidentValue>
    </StyledRedirect>
  );
};

export default EntityDisplayValue;
